import React from 'react';
import ReactionImage from './ReactionImage';

export default function HomeActivityLog(props) {
  const {t} = props;

  return (
    <div className='page'>
      <p className='title'>{t("Home Activity Log")}</p>
      <table className='homeActivityLog'>
        <thead>
          <tr>
            <th>{t("Goal")}</th>
            <th>{t("Activity we tried")}</th>
            <th>{t("how_it_went")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t("example_goal")}</td>
            <td>{t("example_activity")}</td>
            <td><ReactionImage /></td>
          </tr>
          <tr>
            <td /><td />
            <td><ReactionImage /></td>
          </tr>
          <tr>
            <td /><td />
            <td><ReactionImage /></td>
          </tr>
          <tr>
            <td /><td />
            <td><ReactionImage /></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}